import { render, staticRenderFns } from "./ShowDetailsBtn.vue?vue&type=template&id=f033217e&"
import script from "./ShowDetailsBtn.vue?vue&type=script&lang=js&"
export * from "./ShowDetailsBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports